import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { TranslateModule } from '@ngx-translate/core';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)},
  {
    path: 'lexus',
    loadChildren: () => import('./lexus-layout/lexus-layout.module').then(m => m.LexusLayoutModule)
  },
  {
    path: 'toyota',
    loadChildren: () => import('./toyota-layout/toyota-layout.module').then(m => m.ToyotaLayoutModule)

  },
  {
    path: 'admin',
    loadChildren: () => import('./admin/admin.module').then(m => m.AdminModule)

  },
  {
    path: 'toyotaguide',
    loadChildren: () => import('./toyota-first-guide-setup/toyota-first-guide-setup.module').then(m => m.ToyotaFirstGuideSetupModule)

  },
  {
    path: 'lexusguide',
    loadChildren: () => import('./lexus-first-guide-setup/lexus-first-guide-setup.module').then(m => m.LexusFirstGuideSetupModule)

  },
  {
    path: '**',
    loadChildren: () => import('./shared/shared.module').then(m => m.SharedModule)
  }
  ,
  {
    path: '404',
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'enabled' }), TranslateModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
